"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFinite;

var _setup = require("./_setup.js");

var _isSymbol = _interopRequireDefault(require("./isSymbol.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Is a given object a finite number?
function isFinite(obj) {
  return !(0, _isSymbol.default)(obj) && (0, _setup._isFinite)(obj) && !isNaN(parseFloat(obj));
}